import { LOCALE, LocaleType } from '@strava/constants';
import { Language, MapType } from '@strava/mre';

import { MarkerType } from './types';

export const WASM_MRE_RELEASES_BASE_URL =
  'https://wre-assets.prod.mapping.strava.com/releases';

export const MAP_TYPES = {
  STRAVA_TOPO_LIGHT: MapType.STRAVA_TOPO_LIGHT,
  STRAVA_SATELLITE_SUMMER: MapType.STRAVA_SATELLITE_SUMMER,
  STRAVA_HYBRID: MapType.STRAVA_HYBRID
} as const;

export const MAP_TYPE_ANALYTICS_VALUES: Record<number, string> = {
  [MAP_TYPES.STRAVA_TOPO_LIGHT]: 'standard',
  [MAP_TYPES.STRAVA_SATELLITE_SUMMER]: 'satellite',
  [MAP_TYPES.STRAVA_HYBRID]: 'hybrid'
} as const;

export const MARKER_TYPES_CONFIG: Record<
  MarkerType,
  { type: string; position: string }
> = {
  // match marker type names to filters in style.json files in FatmapMobileSDK
  'route-scrub': { type: 'route', position: 'scrub' }
} as const;

export const MAP_LAYERS = {
  stravaPoints: 'strava_points',
  stravaRoute: 'strava_route',
  stravaActivity: 'strava_activity',
  waypoints: 'waypoints',
  custom: 'custom'
} as const;

// Note: 0.5 seconds, should correspond to animation duration value of `.playPauseIcon` in CSS
// Note: JavaScript + CSS is required here in order to 'restart' the animation on change of `playbackState` to `playing` or `paused`
export const PLAY_PAUSE_ICON_DISPLAY_TIME = 500;

// Start / End object positions
export const START_OBJECT_POSITION = 'start';
export const END_OBJECT_POSITION = 'finish';

export const FLYOVER_PREVIEW_DURATION = 6000; // 6 seconds

export const STRAVA_LOCALE_TO_MRE_SUPPORTED_LANGUAGE: Record<
  Exclude<LocaleType, typeof LOCALE.idID | typeof LOCALE.nlNL>, // Indonesian and Dutch are not supported by MRE
  Language
> = {
  [LOCALE.deDE]: Language.DE,
  [LOCALE.enGB]: Language.EN,
  [LOCALE.enUS]: Language.EN,
  [LOCALE.esES]: Language.ES,
  [LOCALE.es419]: Language.ES,
  [LOCALE.frFR]: Language.FR,
  [LOCALE.itIT]: Language.IT,
  [LOCALE.jaJP]: Language.JA,
  [LOCALE.ptBR]: Language.PT,
  [LOCALE.ptPT]: Language.PT,
  [LOCALE.ruRU]: Language.RU,
  [LOCALE.zhCN]: Language.ZH_HANS,
  [LOCALE.zhTW]: Language.ZH_HANT
} as const;

export const MAP_ZOOM_DELAY_MS = 300; // Duration to apply zoom speed for (in ms) when zooming in/out via UI controls (MapViewControls)
